import React from "react";
import { FiRefreshCw, FiClock } from "react-icons/fi";
import { MdCheckCircleOutline } from "react-icons/md";


export default function StatusBadge({ status }) {
  // Complete / Completed
  if (status === "Complete" || status === "Completed") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 text-emerald-600 border border-emerald-200 px-3 py-1 text-xs font-semibold">
        <MdCheckCircleOutline size={16} />
        Complete
      </span>
    );
  }

  // InProgress
  if (status === "InProgress" || status === "In Progress") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 text-indigo-600 border border-indigo-200 px-3 py-1 text-xs font-semibold">
        <FiRefreshCw size={16} className="animate-spin" />
        In Progress
      </span>
    );
  }

  // Pending (or Default)
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 text-amber-600 border border-amber-200 px-3 py-1 text-xs font-semibold">
      <FiClock size={16} />
      Pending
    </span>
  );
}